export default __webpack_public_path__ + "static/media/gatsby.91555432.png";